/**
 * 【KYMW1400】コマ情報VO
 *
 * @export KomaInfoModel
 * @class KomaInfoModel
 */
export class KomaInfoModel {
  /**
   * セクションID
   */
  public sectionId = Number(0);

  /**
   * 始点X
   */
  public positionX = Number(0);

  /**
   * 始点Y
   */
  public positionY = Number(0);

  /**
   * 幅
   */
  public sizeW = Number(0);

  /**
   * 高さ
   */
  public sizeH = Number(0);

  /**
   * Pコード
   */
  public pCode = String('');

  /**
   * 掲載料請求枠数
   */
  public publishAmountLimitNum = Number(0);

  /**
   * 注文コード
   */
  public orderNum6Digits = String('');

  /**
   * 適応開始受注コード
   */
  public startOrderCode = String('');

  /**
   * 受付開始受注コード
   */
  public receiptSOrderCode = String('');

  /**
   * アイテムコード
   */
  public itemCode = String('');

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('');
}
